import { AiResponseReviewQueryModel } from "@app/operations/ai-response-review/interfaces";
import {
  SortAiResponseReviewColumnEnum,
  SortDirectionEnum,
  FilterBoolEnum
} from "@app/operations/ai-response-review/enums";

const DEFAULT_START_DATE_DAYS_AGO = 90;

export const getDefaultStartDate = (): Date => {
  const date = new Date();
  date.setDate(date.getDate() - DEFAULT_START_DATE_DAYS_AGO);
  return date;
};

export const getDefaultAiResponseReviewFilters = (): AiResponseReviewQueryModel => ({
  devResolved: FilterBoolEnum.All,
  pageNumber: 1,
  pageSize: 50,
  sortColumn: SortAiResponseReviewColumnEnum.CreatedDate,
  sortDirection: SortDirectionEnum.Descending,
  startDate: getDefaultStartDate(),
  tableDownloaded: FilterBoolEnum.All,
  tableGenerated: FilterBoolEnum.All
});
